export default __webpack_public_path__ + "f86cf17112cb02f5a2905676b4ab15c3.jpg";